module.exports = __webpack_public_path__ + "media/images/company-placeholder-880ca1f9.svg";